import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-2"},[_c('bread-crumbs',{attrs:{"items":_vm.items}}),_c(VTabs,{attrs:{"grow":""},model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},_vm._l((_vm.tabs),function(tab){return _c(VTab,{key:tab.index,attrs:{"to":tab.href}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }